(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-selector-component')) {
    // Pages déjà chargées (HTML de la fiche + titre), partagées entre les instances.
    const bundlePageCache = {};

    class BundleSelectorComponent extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.addButton = this.querySelector('[data-bundle-add]');
        this.ctaPrice = this.querySelector('[data-bundle-cta-price]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.section = this.closest('.shopify-section');
        this.switchRequest = 0;

        this.addEventListener('change', (event) => {
          if (event.target.matches('.bundle-option__radio')) this.switchTo(event.target);
        });
        this.addButton.addEventListener('click', () => this.addToCart());

        const input = this.selectedInput;
        if (input && this.ctaPrice) this.ctaPrice.textContent = input.dataset.price;
        this.prefetchPages();
      }

      get selectedInput() {
        return this.querySelector('.bundle-option__radio:checked');
      }

      // Charge la page d'un produit et garde sa fiche (section principale) et son titre.
      fetchPage(url) {
        if (!bundlePageCache[url]) {
          bundlePageCache[url] = fetch(url, { headers: { Accept: 'text/html' } })
            .then((response) => (response.ok ? response.text() : null))
            .then((html) => {
              if (!html) return null;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const section = doc.querySelector('bundle-selector-component')?.closest('.shopify-section');
              return section ? { html: section.outerHTML, title: doc.title } : null;
            })
            .catch(() => null)
            .then((page) => {
              if (!page) delete bundlePageCache[url];
              return page;
            });
        }
        return bundlePageCache[url];
      }

      prefetchPages() {
        const run = () =>
          this.querySelectorAll('.bundle-option__radio').forEach((input) => {
            if (input.value !== this.dataset.pageOption) this.fetchPage(input.dataset.productUrl);
          });
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 4000 });
        } else {
          setTimeout(run, 2000);
        }
      }

      // Remplace la fiche produit par celle de la formule choisie et met l'adresse à jour.
      async switchTo(input) {
        const url = input.dataset.productUrl;
        if (!url || !this.section || input.value === this.dataset.pageOption) return;

        const request = ++this.switchRequest;
        this.setAttribute('aria-busy', 'true');
        const page = await this.fetchPage(url);
        if (request !== this.switchRequest || !this.isConnected) return;

        const next = page && new DOMParser().parseFromString(page.html, 'text/html').querySelector('.shopify-section');
        if (!next) {
          window.location.href = url;
          return;
        }

        // Garde la carte cliquée au même endroit de l'écran (le titre peut changer de hauteur).
        const top = input.closest('label').getBoundingClientRect().top;
        this.section.replaceWith(next);
        document.title = page.title;
        history.replaceState(history.state, '', url);

        const checked = next.querySelector('.bundle-option__radio:checked');
        if (checked) {
          window.scrollBy({ top: checked.closest('label').getBoundingClientRect().top - top, behavior: 'instant' });
          checked.focus({ preventScroll: true });
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      setBusy(busy) {
        this.addButton.setAttribute('aria-busy', String(busy));
      }

      async addToCart() {
        const input = this.selectedInput;
        if (!input) return;
        if (this.errorEl) this.errorEl.hidden = true;

        const items = [{ id: Number(input.dataset.variantId), quantity: 1 }];
        if (!items[0].id) {
          this.showError(this.dataset.errorConfig);
          return;
        }

        const sections = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean)
          .join(',');
        const cartUrl = this.dataset.cartUrl;

        this.setBusy(true);
        try {
          const addResponse = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
          });
          const added = await addResponse.json();
          if (!addResponse.ok || added.status) {
            this.showError(added.description || added.message || this.dataset.errorAdd);
            return;
          }

          const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: this.id,
                data: { source: 'bundle-selector', itemCount: cart.item_count, sections: added.sections },
              },
            })
          );

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = cartUrl;
          }
        } catch (error) {
          this.showError(this.dataset.errorNetwork);
        } finally {
          this.setBusy(false);
        }
      }
    }

    customElements.define('bundle-selector-component', BundleSelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["restock-notify"] && !Shopify.designMode) return;
  try {
    class RestockNotify extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || document;

      // Bouton « M'avertir » : déplie le formulaire et place le curseur dans le champ e-mail
      this.trigger = this.querySelector('[data-restock-trigger]');
      this.onTrigger = () => {
        this.setAttribute('data-open', '');
        this.trigger.setAttribute('aria-expanded', 'true');
        const input = this.querySelector('input[type="email"]');
        setTimeout(() => input?.focus({ preventScroll: true }), 120);
      };
      this.trigger?.addEventListener('click', this.onTrigger);

      this.onVariantUpdate = (event) => {
        const variant = event.detail?.resource;
        if (!variant) return;
        // Visible seulement si la variante choisie est épuisée
        this.toggleAttribute('data-sold-out', variant.available === false);
        if (!this.hasAttribute('data-force-preview')) this.hidden = variant.available !== false;
        if (this.dataset.hasVariants === 'true') {
          const tags = this.querySelector('[data-restock-tags]');
          const slug = String(variant.title || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          if (tags) tags.value = `restock,${this.dataset.tagProduct},${this.dataset.tagProduct}-${slug}`;
        }
      };
      this.section.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTrigger);
      this.section?.removeEventListener('variant:update', this.onVariantUpdate);
    }
  }

  if (!customElements.get('restock-notify')) customElements.define('restock-notify', RestockNotify);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ugc-play]');
    if (!btn) return;
    const media = btn.parentElement;
    const video = media.querySelector('video');
    if (!video) return;
    if (video.paused) {
      document.querySelectorAll('.pdp-ugc__media.is-playing').forEach((other) => {
        if (other === media) return;
        other.querySelector('video').pause();
        other.classList.remove('is-playing');
        const otherBtn = other.querySelector('[data-ugc-play]');
        otherBtn.setAttribute('aria-label', otherBtn.dataset.labelPlay);
      });
      video.muted = false;
      video.play();
      media.classList.add('is-playing');
      btn.setAttribute('aria-label', btn.dataset.labelPause);
    } else {
      video.pause();
      media.classList.remove('is-playing');
      btn.setAttribute('aria-label', btn.dataset.labelPlay);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
